export enum AwardPurchasingType {
  IN_AND_OUT = 'IN_AND_OUT',
  ONGOING = 'ONGOING',
}
